import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: "https://securewealthhub.in/api",
  headers: {
    "Content-Type": "application/json",
  },
   
  adapter: "xhr",
});
